export default __webpack_public_path__ + "static/media/onboarding-desktop.75c679a1.png";